/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentsFolderStatus {
    DRAFT = 'Draft',
    OPEN = 'Open',
    COMPLETED = 'Completed',
}
